let globals = {
  trackingVersion: process.env.trackingVersion,
}

export const getGlobals = () => globals

export const setGlobals = (newWizardGlobals) => {
  globals = Object.assign({}, globals, newWizardGlobals)

  return globals
}
